export enum TipoProgramaList {
  UniaoFazAVida = 'uniaoFazAVida',
  CooperativaEscolar = 'cooperativaEscolar',
  FinancasNaMochila = 'financasNaMochila',
}

export enum TipoPrograma {
  UniaoFazAVida = '0',
  CooperativaEscolar = '1',
  FinancasNaMochila = '2',
}

export enum EscolaEditTabs {
  Informacoes = "informacoes",
  ProgramasEducacionais = "programas-educacionais",
}
